/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_IntroInputs */

const en_guide_json_schema_intro = /** @type {(inputs: Guide_Json_Schema_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema is a vocabulary that lets you annotate and validate JSON documents. It defines the expected structure, data types, and constraints for your JSON data. Think of it as TypeScript types, but for any JSON data: not just JavaScript objects.`)
};

const ko_guide_json_schema_intro = /** @type {(inputs: Guide_Json_Schema_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 JSON 문서에 주석을 달고 유효성을 검사할 수 있는 어휘입니다. JSON 데이터의 예상 구조, 데이터 타입, 제약 조건을 정의합니다. TypeScript 타입과 비슷하지만, JavaScript 객체뿐만 아니라 모든 JSON 데이터에 적용됩니다.`)
};

const ja_guide_json_schema_intro = /** @type {(inputs: Guide_Json_Schema_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaは、JSONドキュメントに注釈を付けて検証するための語彙です。JSONデータの期待される構造、データ型、制約を定義します。TypeScriptの型のようなものですが、JavaScriptオブジェクトだけでなく、あらゆるJSONデータに対応します。`)
};

/**
* | output |
* | --- |
* | "JSON Schema is a vocabulary that lets you annotate and validate JSON documents. It defines the expected structure, data types, and constraints for your JSON ..." |
*
* @param {Guide_Json_Schema_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_intro = /** @type {((inputs?: Guide_Json_Schema_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_intro(inputs)
	if (locale === "ko") return ko_guide_json_schema_intro(inputs)
	return ja_guide_json_schema_intro(inputs)
});